<template>
  <div class="appointmentList-view" :key="i18nUpdateKey">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('business', 'formList')" name="first"> <addForm v-if="activeName == 'first'" /> </el-tab-pane>
      <el-tab-pane :label="$t('business', 'basicSettings')" name="second"> <formSetting v-if="activeName == 'second'" /> </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import addForm from "./components/advancedForm/addForm";
import formSetting from "./components/advancedForm/formSetting";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  components: {
    addForm,
    formSetting,
    
  },
  data() {
    return {
      activeName:'first'
    };
  },
  mounted() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },

  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
</style>